export default __webpack_public_path__ + "static/easyApproval-b87635964a06202ef8c9f6672665e9b4.png";